import { Controller } from "stimulus";

const ADD_NEW_ID = "add-new-un-code";
const HIDDEN_CLASS = "hidden";
const UN_CODE_ID = "un_code_id_";
const UN_DESCRIPTION_ID = "un_description_";
const PACKING_GROUP_ID = "packing_group_";
const IMO_CLASS_ID = "imo_class_";
const SUBSIDIARY_RISK_ID = "subsidiary_risk_";

export default class extends Controller {
  static targets = ["checkbox"];

  dangerousGoodsSelect(event) {
    if (this.checkboxTarget.checked) {
      document
        .getElementById(`${event.target.dataset.value}-${ADD_NEW_ID}`)
        .removeAttribute(HIDDEN_CLASS);
    } else {
      document
        .getElementById(`${event.target.dataset.value}-${ADD_NEW_ID}`)
        .setAttribute(HIDDEN_CLASS, true);
    }
  }

  unCodeSelect(event) {
    const selected_id = event.target.value;
    const element_id = event.target.id.replace(UN_CODE_ID, "");

    $.getJSON(
      `/admin/un_codes/${selected_id}`,
      function (element_id, data) {
        this.set_un_code_values(data, element_id);
      }.bind(this, element_id)
    );
  }

  set_un_code_values(data, element_id) {
    document.getElementById(`${UN_DESCRIPTION_ID}${element_id}`).value = data.un_description;
    document.getElementById(`${PACKING_GROUP_ID}${element_id}`).value = data.packing_group;
    document.getElementById(`${IMO_CLASS_ID}${element_id}`).value = data.imo_class;
    document.getElementById(`${SUBSIDIARY_RISK_ID}${element_id}`).value = data.subsidiary_risk;
  }
}
